import getFeaturedImage from "./getFeaturedImage";

// function to generate schema content for an image
const getImageSchema = (name = "", contentUrl = "", description = "") => {
  const data: any = {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
  };

  if (name) {
    data.name = name;
  }
  if (contentUrl) {
    data.contentUrl = contentUrl;
  }
  if (description) {
    data.description = description;
  }

  return data;
};

const generateImageSchemaData = (data = []) => {
  const imagesSchemaData = data.map((item: any) => {
    const NUMBER_OF_IMAGES = 5;
    const featuredImage = getFeaturedImage(item?.images);

    const updatedImageList = featuredImage
      ? [
          featuredImage,
          ...(item?.images.filter((image: any) => image?.base_path !== featuredImage?.base_path) ||
            []),
        ]
      : item?.images;

    const imageSchemas = updatedImageList
      .slice(0, Math.min(updatedImageList?.length, NUMBER_OF_IMAGES))
      .map((img: any) => getImageSchema(img?.caption, img?.path, img?.type));

    return imageSchemas;
  });

  const flattenedSchemaData = imagesSchemaData.flat();

  return flattenedSchemaData;
};

export default generateImageSchemaData;
